import { render } from "./DashboardStaff.vue?vue&type=template&id=47292462&scoped=true"
import script from "./DashboardStaff.vue?vue&type=script&lang=js"
export * from "./DashboardStaff.vue?vue&type=script&lang=js"

import "./DashboardStaff.vue?vue&type=style&index=0&id=47292462&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47292462"]])

export default __exports__